import client from "../api-client"

export default class Users {
  static get = (user_id) => {
    return client(`users?user_id=${user_id}`)
  }
}
